
export enum StrategyRuleName {
     EntryThresholdPercentage = 'entry_threshold_percentage',
     EntryThresholdAbsolute = 'entry_threshold_absolute',
     StopLossThresholdPercentage = 'stop_loss_threshold_percentage',
     StopLossThresholdAbsolute = 'stop_loss_threshold_absolute',
     ProfitTakingThresholdPercentage = 'profit_taking_threshold_percentage',
     ProfitTakingThresholdAbsolute = 'profit_taking_threshold_absolute'
}
    